import { useState, useContext } from 'react';
import ConsentContentContext from '../../context/contentContext';
import ConsentAndDisclosureGroup1 from './consentAndDisclosureGroup1';
import ConsentAndDisclosureGroup2 from './consentAndDisclosureGroup2';
import ConsentAndDisclosureAllOthers from './consentAndDisclosureAllOthers';


const CountrySelection = (props)=>{
    const {onVerifyClearHandler, user} = props;
    const {country_selection, consent_data} = useContext(ConsentContentContext);

    const [countryGroup, setCountryGroup] = useState('');
    const [displayData, setDisplayData] = useState([]);
    
    const startVerificationHandler = (group, consent_ids) => {
        setCountryGroup(group);
        setDisplayData(consent_ids.map(id => consent_data[id]));
    };

    return (
        countryGroup === '' ? (
<div className='white-box'>
            <div className='location-form-header'>Please Select Your Location</div>
            <div>
                {
                    country_selection && country_selection.map(item => <button
                    key={item.consent_group}
                        className='location-form-button'
                        onClick={()=> startVerificationHandler(item.consent_group, item.consent_available)}
                        >
                            {item.button_text}
                        </button>
                    )
                }
            </div>
        </div>
        ) : (
            countryGroup === 'group1' ? (
                <ConsentAndDisclosureGroup1 
                onVerifyClearHandler={onVerifyClearHandler} 
                user={user} 
                displayData={displayData}/>
            ) : countryGroup === 'group2' ? (
                <ConsentAndDisclosureGroup2 
                onVerifyClearHandler={onVerifyClearHandler} 
                displayData={displayData}/>
            ) : countryGroup === 'allOthers' ? (
                <ConsentAndDisclosureAllOthers 
                onVerifyClearHandler={onVerifyClearHandler}
                displayData={displayData}/>
            ) : <></>
        )   
    )
}

export default CountrySelection;